angular.module('hotEchartsMapModule', [])
    .directive('hotEchartsMapDir', ['$q', 'initHotHead', '$timeout', 'trsHttpService', function($q, initHotHead, $timeout, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionJsons: "="
            },
            link: function(scope, iElement, iAttrs) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '450px',
                        width: '100%'
                    };
                        var data=scope.optionJsons,mapData=[],reg=new RegExp("市|省|壮族自治区|维吾尔自治区|回族自治区|自治区|特别行政区|特别行政区");
                        var option;
                        for(var i=0;i<data.length;i++){
                            mapData.push({
                                name:data[i].KEYWORD.replace(reg,""),
                                value:data[i].VALUE
                        });
                        }
                        if (data=== '') return;
                        //将“其他”放到最后
                        scope.chinaMap = [];
                        var other = [];
                        angular.forEach(data, function(array, key) {
                            if (array.KEYWORD == '其他') {
                                other = data.splice(key, 1);
                            }
                        });
                        if (other[0] !== undefined) {
                            for (var i = 9; i < data.length; i++) {
                                other[0].VALUE += data[i].VALUE;
                                other[0].PERCENT += data[i].PERCENT;
                            }
                            data.splice(9, 0, other[0]);
                        }
                        scope.chinaMap = data;
                        var nums = [];
                        for (var k in data) {
                            nums.push(data[k].VALUE);
                        }
                        scope.chinaMapMax = Math.max.apply(null, nums);
                        var oldData = [
                            { name: '北京', value: 0 },
                            { name: '天津', value: 0 },
                            { name: '上海', value: 0 },
                            { name: '重庆', value: 0 },
                            { name: '河北', value: 0 },
                            { name: '河南', value: 0 },
                            { name: '云南', value: 0 },
                            { name: '辽宁', value: 0 },
                            { name: '黑龙江', value: 0 },
                            { name: '湖南', value: 0 },
                            { name: '安徽', value: 0 },
                            { name: '山东', value: 0 },
                            { name: '新疆', value: 0 },
                            { name: '江苏', value: 0 },
                            { name: '新疆', value: 0 },
                            { name: '江西', value: 0 },
                            { name: '湖北', value: 0 },
                            { name: '广西', value: 0 },
                            { name: '甘肃', value: 0 },
                            { name: '山西', value: 0 },
                            { name: '内蒙古', value: 0 },
                            { name: '陕西', value: 0 },
                            { name: '吉林', value: 0 },
                            { name: '福建', value: 0 },
                            { name: '贵州', value: 0 },
                            { name: '广东', value: 0 },
                            { name: '青海', value: 0 },
                            { name: '西藏', value: 0 },
                            { name: '四川', value: 0 },
                            { name: '宁夏', value: 0 },
                            { name: '海南', value: 0 },
                            { name: '台湾', value: 0 },
                            { name: '香港', value: 0 },
                            { name: '澳门', value: 0 }
                        ];
                        for (var q in mapData) {
                            for (var i in oldData) {
                                if (mapData[q].name == oldData[i].name) {
                                    oldData[i].value = mapData[q].value;
                                    // oldData[i].per = data[q].PERCENT;
                                }
                            }
                        }
                      option = {
                            tooltip: {
                                trigger: 'item'
                            },
                            dataRange: {
                                min: 0,
                                max: scope.chinaMapMax,
                                orient: 'horizontal',
                                x: 'left',
                                y: 'bottom',
                                text: ['报道量高', '报道量低'], // 文本，默认为数值文本
                                calculable: true,
                                inRange: {
                                    color: ['#E3EDFF ','#BBD2FF' ,'#d64541 ']
                                }
                            },
                            roamController: {
                                show: false,
                                x: 'right',
                                mapTypeControl: {
                                    'china': true
                                }
                            },
                            series: [
                                {
                                name: '报道数',
                                type: 'map',
                                mapType: 'china',
                                roam: false,
                                selectedMode: "single",
                                showLegendSymbol:true,
                                itemStyle: {
                                    normal: {
                                        borderColor: '#fff',
                                        label: {
                                            show: true,
                                            textStyle: {
                                                color: "#4E4E4E"
                                            }
                                        }
                                    },
                                    emphasis: {
                                        label: {
                                            show: true,
                                            textStyle: {
                                                color: "#4E4E4E",
                                            }
                                        }
                                    }
                                },
                                data: oldData
                            }]
                        };
                    require([
                        'echarts',
                        './lib/echarts/dist/china.js'
                    ], function(echarts) {
                        var myChart = echarts.init(iElement[0]);
                        myChart.setOption(option);
                        window.onresize = myChart.resize;
                    });
                }, 500);
            }
        };
    }]);
